import { render } from "./Regist.vue?vue&type=template&id=d6f9a9fa&scoped=true"
import script from "./Regist.vue?vue&type=script&lang=js"
export * from "./Regist.vue?vue&type=script&lang=js"

import "./Regist.vue?vue&type=style&index=0&id=d6f9a9fa&scoped=true&lang=css"

import exportComponent from "E:\\heguang\\bm365\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6f9a9fa"]])

export default __exports__